/* HE Aug 2026 (Fix 37): visible desktop search bar in the header.
   Renders a search-bar-styled button next to the existing
   .js-search-header icon and opens the theme's predictive search
   overlay on click (same behavior as the icon, which stays the
   mobile experience). Styling: assets/he-search-bar.css. Loaded
   from layout/theme.liquid. */
(function () {
  if (window.heSearchBarInit) return;
  window.heSearchBarInit = true;

  function init() {
    var triggers = Array.prototype.slice.call(document.querySelectorAll('.js-search-header'));
    if (!triggers.length) return;
    var visible = triggers.filter(function (t) { return t.offsetWidth > 0; });
    var trigger = visible[0] || triggers[0];
    if (trigger.nextElementSibling && trigger.nextElementSibling.classList && trigger.nextElementSibling.classList.contains('he-search-bar')) return;

    var bar = document.createElement('button');
    bar.type = 'button';
    bar.className = 'he-search-bar';
    bar.setAttribute('aria-label', 'Search products');
    bar.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 64 64" width="16" height="16"><path d="M47.16 28.58A18.58 18.58 0 1 1 28.58 10a18.58 18.58 0 0 1 18.58 18.58zM54 54L41.94 41.94" fill="none" stroke="currentColor" stroke-width="4"></path></svg><span>Search products…</span>';
    bar.addEventListener('click', function (evt) {
      evt.preventDefault();
      trigger.click();
    });
    trigger.parentNode.insertBefore(bar, trigger.nextSibling);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
